<template>
	<div class="tab-pane-reinstall-wrapper">

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- если запущен процесс или нет доступа -->
		<template v-if="!Access">
			<div class="text-center margin-top-5">
				<div v-if="serviceStatus && (serviceStatus.loader || serviceStatus.timer)" style="margin: 80px auto">
					<span v-if="serviceStatus['loader']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="serviceStatus['timer']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }}</span>
				</div>
				<template v-else>
					<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
					<br>
					<span class="w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
				</template>
			</div>
		</template>
		<!-- нет активного процесса и есть права -->
		<template v-else>

			<div class="w5-form-row">
				<Field
					v-if="templateField && Access"
					crud="vds"
					action="view"
					v-model="templateValue"
					:isVisibleRow="true"
					:removeRightPadding="true"
					:Field="templateField"
					:formFields="formFields"
					:planField="planData"
					:dc="dc && 'id' in dc ? dc.id : null"
					@focus="onFocus(templateField)"
					@templateTab="onTemplateTab"
					@templateInput = "onTemplateInput"
					@backupList="onBackupList" />
			</div>

			<div class="w5-form-row">
				<Field
					v-if="hostField && Access && templateValue && currentTab !== 'backup' && currentTab !== 'iso'"
					:isVisibleRow="true"
					crud="vds"
					action="view"
					v-model="hostValue"
					:Field="hostField"
					@focus="onFocus(hostField)"
					@valueChanged="fieldChanged"
					:removeRightPadding="true" />
			</div>

			<div class="w5-form-row">
				<Field
					v-if="sshkeyField && Access && templateValue && currentTab !== 'backup' && currentTab !== 'iso'"
					:isVisibleRow="true"
					crud="vds"
					action="view"
					v-model="sshkeyValue"
					:Field="sshkeyField"
					@focus="onFocus(sshkeyField)"
					@valueChanged="fieldChanged"
					:removeRightPadding="true" />
			</div>

			<!-- подсказка-ссылка -->
			<div v-if="linkHint && linkHintShowIf" class="w5-info-link">
				<font-awesome-icon icon="link" />
				<span v-withSafeTags="linkHintHtml(linkHint)"></span>
			</div>

			<!-- кнопка -->
			<div class="w5-form-row" style="margin-top: 10px">
				<div
					class="btn btn-submit-danger margin-top-10 font-weight-300"
					:class="{
						'disable': isDisbledReinstallButton
					}"
					@click="reInstall">
					<template v-if="currentTab === 'backup'">{{ 'service/backup_restore' | ftc }}</template>
					<template v-else>{{ 'service/reinstall' | ftc }}</template>
				</div>
			</div>
		</template>

		<!-- диалог подтверждения -->
		<transition name="modal">
			<div v-show="showConfirmModal" @click="hideConfirmModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ confirmModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideConfirmModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(confirmModalBodyText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit-danger pull-right" :disabled="confirmModalTimer && confirmModalTimer > 0 ? 'disabled' : false" @click="changeTemplateStart">{{ modalConfirmButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabReinstall',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'planId',
		'planData',
		'access',
		'status',
		'serviceStatus',
		'vdsId',
		'value',
		'parentError',
		'vdsName',

		'template',
		'host',
		'sshkey',
		'account',
		'backup',
		'reiso',
		'dc'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// выбранный для переустановки шаблон
			templateValue: null,
			templateField: null,

			// имя хоста
			hostValue: null,
			hostField: null,

			// ssh-ключ
			sshkeyValue: null,
			sshkeyField: null,

			// выбранный для переустановки бэкап
			backupValue: null,
			backupField: null,

			// выбранный для переустановки ISO
			reisoValue: null,
			reisoField: null,

			localErrorMessage: '',

			showConfirmModal: false,
			confirmModalTimer: false,
			confirmModalTimerHandle: false,
			confirmModalTitle: '',
			confirmModalBodyText: '',

			// доступ
			Access: false,
			Status: null,
			Error: '',

			// стартанули переустановку или нет
			isReinstallStrated: false,

			// текущая вкладка
			currentTab: ''
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		// ссылки-подсказки
		linkHint() {
			if (this.Config &&
				this.Config['vds'] &&
				this.Config['vds']['hint-link'] &&
				this.Config['vds']['hint-link']['create'] &&
				this.Config['vds']['hint-link']['create'].length)
			{
				let _result = false
				this.Config['vds']['hint-link']['create'].some(item => {
					if (item.showIfField === 'sshkey_id')
					{
						_result = item
						return true
					}
				})

				return _result
			}

			return false
		},
		// видимость ссылки-подсказки привязанная к полю
		linkHintShowIf() {
			if (!this.sshkeyField) return false
			if (this.currentTab === 'backup' || this.currentTab === 'iso') return false

			return this.sshkeyField['_visible']
		},
		// кнопка на модальном диалоге удаления
		modalConfirmButtonTitle() {
			if (this.confirmModalTitle === 'service/reinstall')
			{
				if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc('service/reinstall')
				return this.localeFtc('service/reinstall') + ' - ' + this.confirmModalTimer
			}

			if (this.confirmModalTitle === 'service/restore')
			{
				if (!this.confirmModalTimer || this.confirmModalTimer <= 0) return this.localeFtc('service/restore')
				return this.localeFtc('service/restore') + ' - ' + this.confirmModalTimer
			}

			return ''
		},
		// дизаблена кнопка переустановки шаблона?
		isDisbledReinstallButton() {
			// общая проверка
			if (!this.Access || this.Status !== 'active' || this.isReinstallStrated)
				return true

			// если нет текущего тарифа
			if (!this.planId) return true

			// проверка значения - поля
			if (!this.templateField && !this.backupField && !this.reisoField)
				return true

			// проверка значения - значения
			if (!this.templateValue && !this.backupValue && !this.reisoValue)
				return true

			// если это шаблон
			if (
				(this.currentTab === 'template' || this.currentTab === 'template-panel') &&
				this.templateValue && this.templateField && this.templateField.list && this.templateField.list.length
			)
			{
				// допустим ли шаблон для текущего тарифа
				// ищем шаблон
				let temp = null
				this.templateField.list.some(t => {
					if (String(t.id) === String(this.templateValue))
					{
						temp = t
						return true
					}
				})
				// если не нашли или нет списка допустымх тарифов
				if (!temp && !temp.plans && !temp.plans.length) return true

				// проверяем на совместимость
				return !temp.plans.some(p => {
					if (String(p) === String(this.planId))
					{
						return true
					}
				})
			}
			// если это бэкап
			else if (this.currentTab === 'backup' &&
				this.backupValue && this.backupField && this.backupField.list && this.backupField.list.length)
			{
				// допустим ли бэкап для текущего тарифа
				// ищем бэкап
				let temp = null
				this.backupField.list.some(t => {
					if (String(t.id) === String(this.backupValue))
					{
						temp = t
						return true
					}
				})
				// если не нашли или нет списка допустымх тарифов
				if (!temp && !temp.plans && !temp.plans.length) return true

				// проверяем на совместимость
				return !temp.plans.some(p => {
					if (String(p) === String(this.planId))
					{
						return true
					}
				})
			}
			// если это iso
			else if (this.currentTab === 'iso' &&
				this.reisoValue && this.reisoField && this.reisoField.list && this.reisoField.list.length)
			{
				// ищем iso
				let temp = null
				this.reisoField.list.some(t => {
					if (String(t.id) === String(this.reisoValue))
					{
						temp = t
						return true
					}
				})
				// если не нашли
				if (!temp) return true

				// иначе - разлочиваем кнопку
				return false
			}

			// по умолчанию лочим кнопку
			return true
		},
		// набор всех форм
		formFields() {
			let answer = []

			// account
			if (this.account && this.account.account_id)
				answer.push(
					Object.assign(
						{ _field_name: 'account_id' },
						this.account.account_id
					)
				)

			// шаблон
			if (this.templateField)
				answer.push(this.templateField)

			// бэкап
			if (this.backupField)
				answer.push(
					Object.assign(
						{ _field_name: 'backup_id' },
						this.backupField
					)
				)

			// iso
			if (this.reisoField)
				answer.push(
					Object.assign(
						{ _field_name: 'iso_id' },
						this.reisoField
					)
				)

			// должен быть массив массивов
			return [answer]
		}

	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	created() {
		this.templateField = Object.assign({}, this.template)
		this.templateValue = this.value

		this.hostField = Object.assign({}, this.host)
		if (this.hostField && this.hostField['value']) this.hostValue = this.hostField['value']

		this.sshkeyField = Object.assign({}, this.sshkey)
		if (this.sshkeyField &&
			'value' in this.sshkeyField)
		{
			if (this.sshkeyField['value'])
				this.sshkeyValue = this.sshkeyField['value']
			else
			{
				this.sshkeyValue = -1000
				this.$nextTick(() => {
					EventBus.$emit('w5-set-list-field-value', {
						name: 'sshkey_id',
						value: {
							'id': -1000,
							'name': this.localeFtc('sshkey/not_use')
						}
					})
				})
			}
		}

		this.backupField = Object.assign({}, this.backup)
		this.reisoField = Object.assign({}, this.reiso)

		this.Access = this.access
		this.Status = this.status
		this.Error = this.parentError

		// вычисляем условия "showif"
		this.showif()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// преобразует шаблон хинта в HTML
		//---------------------------------------------------------------------
		linkHintHtml(data) {
			if (!data || !data.link || !data.title) return ''

			const title = this.localeFtc(data.title)
			let begin = title.indexOf('[URL]')
			let end = title.indexOf('[/URL]')
			let answer = Helper.escapeHtml(title)

			if (begin > -1 && end > -1)
			{
				answer = answer
					.replace('[URL]', '<a href="' + data.link + '" target="_blank" style="margin: 0">')
					.replace('[/URL]', '</a>')
			}

			return answer
		},
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие диалога
			if (e.keyCode === 27 && this.active) this.hideConfirmModal()
		},
		//---------------------------------------------------------------------
		// фокус на поле
		//---------------------------------------------------------------------
		onFocus(field) {
			field['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// поменялось значение поля
		//---------------------------------------------------------------------
		fieldChanged() {
			this.showif()
		},
		//---------------------------------------------------------------------
		// поменяли вкладку
		//---------------------------------------------------------------------
		onTemplateTab(tab) {
			this.currentTab = tab
		},
		//---------------------------------------------------------------------
		// потомок передал список бэкапов
		//---------------------------------------------------------------------
		onBackupList(list) {
			if (!this.backupField) this.backupField = {}
			this.backupField.list = list
		},
		//---------------------------------------------------------------------
		// поменялось поле для переустановки ОС
		//---------------------------------------------------------------------
		onTemplateInput(data) {
			// проверка
			if (!data || !data.tab) return

			// что конкретно поменялось?
			if (data.tab === 'template' || data.tab === 'template-panel')
			{
				this.templateValue = data.value
				this.backupValue = null
				this.reisoValue = null
			}
			else if (data.tab === 'backup')
			{
				this.templateValue = null
				this.backupValue = data.value
				this.reisoValue = null
			}
			else if (data.tab === 'iso')
			{
				this.templateValue = null
				this.backupValue = null
				this.reisoValue = data.value
			}

			// сами эмулируем изменение поля
			this.fieldChanged()
		},
		//---------------------------------------------------------------------
		// запрос переустановки
		//---------------------------------------------------------------------
		reInstall() {
			// проверка доступа
			if (!this.Access || this.Status !== 'active' || this.Error) return
			// если уже есть процесс
			if (this.isReinstallStrated) return

			// проверка полей
			if (!this.validate()) return

			// закроем диалог
			this.hideConfirmModal()

			// чистим все сообщения
			this.localErrorMessage = ''

			// тексты диалога
			this.confirmModalTitle = 'service/reinstall'
			this.confirmModalBodyText = 'service/reinstall_confirm'

			// тексты диалога для бэкапа
			if (this.currentTab === 'backup' && this.backupValue &&
				this.backupField && this.backupField.list && this.backupField.list.length)
			{
				let _backupName = '#' + this.backupValue
				this.backupField.list.some(b => {
					if (b && String(b.id) === String(this.backupValue))
					{
						_backupName = b.name
						return true
					}
				})

				this.confirmModalTitle = 'service/restore'
				this.confirmModalBodyText = this.localeFtc('service/restore_backup_info')
					.replace('{server}', this.vdsName)
					.replace('{backup}', _backupName)
			}

			// таймер
			this.confirmModalTimer = 5

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModal = true

			// запретим его закрывать родителю
			this.$emit('flagCloseModals', true)

			// запускаем таймер
			this.confirmModalTimerHandle = setInterval(() => {
				this.confirmModalTimer--
				if (this.confirmModalTimer <= 0)
				{
					clearInterval(this.confirmModalTimerHandle)
					this.confirmModalTimerHandle = false
				}
			}, 1000)
		},
		//---------------------------------------------------------------------
		// проверка полей
		//---------------------------------------------------------------------
		validate() {
			// проверка названия хоста
			if (
				(this.currentTab === 'template' || this.currentTab === 'template-panel') &&
				!Helper.validateHostnameForFQDN(this.hostValue)
			)
			{
				this.hostField['_errMsg'] = 'ippool/host_error'
				return false
			}

			// если нет нужных полей
			if (!this.templateField && !this.backupField && !this.reisoField)
			{
				this.templateField['_errMsg'] = 'template/not_selected'
				return false
			}

			// если не выбрано ничего для переустановки
			if (!this.templateValue && !this.backupValue && !this.reisoValue)
			{
				let _errText = ''
				if (this.currentTab === 'backup')
				{
					_errText = 'backup/not_selected'
				}
				else if (this.currentTab === 'iso')
				{
					_errText = 'iso/not_selected'
				}
				else
				{
					_errText = 'template/not_selected'
				}

				this.templateField['_errMsg'] = _errText
				return false
			}

			// все в порядке
			return true
		},
		//---------------------------------------------------------------------
		// показ/скрытие поля
		//---------------------------------------------------------------------
		showif() {
			if (!this.hostField || !this.hostField['_field_name'] ||
				!this.templateField || !this.templateField['_field_name'] ||
				!this.sshkeyField || !this.sshkeyField['_field_name'])
				return

			// массив полей
			let fields = [this.hostField, this.templateField, this.sshkeyField]

			// готовим объекты, где собираем значения и выражения
			let _values = {
				reinstall: 1
			}
			let _expressions = {}

			fields.forEach(field => {
				let _fieldName = field['_field_name']
				let _val = null

				if (_fieldName === 'hostname') _val = this.hostValue
				else if (_fieldName === 'template_id') _val = this.templateValue
				else if (_fieldName === 'sshkey_id') _val = this.sshkeyValue
				// заполняем объект со значениями
				_values[_fieldName.replace(/\[/g, '__').replace(/]/g, '__')] = _val

				// если есть выражение для данного поля
				if (field['showif'])
				{
					// получим выражение
					let _expr = field['showif']
					// подменяем в выражении переменные
					if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
					{
						// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
						let reg = new RegExp(/(\w+) in (\[[0-9,\s-]+\])/gi)

						// проверяем
						if (reg.exec(_expr) !== null)
						{
							_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
						}
						else
						{
							// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
							reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
							let _mtch = null
							if ((_mtch = reg.exec(_expr)) !== null)
							{
								_expr = _expr.replace(_mtch[0], 'w5InArray(' +
									_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
									', ' +
									_mtch[2] +
									') !== -1')
							}
						}
					}
					// type[period] == 0    =>    type__period__ == 0
					else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
					_expressions[_fieldName] = _expr
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = null
				if (e === 'hostname') _field = this.hostField
				else if (e === 'template_id') _field = this.templateField
				else if (e === 'sshkey_id') _field = this.sshkeyField

				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// закрыть диалог
		//---------------------------------------------------------------------
		hideConfirmModal() {
			if (this.confirmModalTimerHandle)
			{
				clearInterval(this.confirmModalTimerHandle)
				this.confirmModalTimerHandle = false
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// старт смены шаблона
		//---------------------------------------------------------------------
		changeTemplateStart() {
			// если таймер активен
			if (this.confirmModalTimer && this.confirmModalTimer > 0) return
			// проверка доступа
			if (!this.Access || this.Status !== 'active' || this.Error) return
			// если есть ошибки
			if (this.hostField['_errMsg'] !== '' || this.templateField['_errMsg'] !== '') return
			// если уже есть процесс
			if (this.isReinstallStrated) return

			// обнулим сообщения
			this.localErrorMessage = ''

			// спрячем пока кнопку
			this.isReinstallStrated = true

			// спрячем поля
			this.hostField._visible = false
			this.templateField._visible = false
			this.sshkeyField._visible = false

			// закроем диалог
			this.hideConfirmModal()

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId

			// если выбран бэкап
			if (this.backupValue)
			{
				_url = this.APIServerUrl + '/service/update/' + this.vdsId +
				`?additional=setRestore&service_id=${this.backupValue}`
			}

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}

						// если выбран шаблон
						if (this.templateValue)
						{
							_post[_dt['model']]['reinstall'] = 1
							_post[_dt['model']]['template_id'] = this.templateValue
							_post[_dt['model']]['hostname'] = this.hostValue

							// если задали ssh-ключ
							if (this.sshkeyValue && String(this.sshkeyValue).trim() !== '' && parseInt(this.sshkeyValue, 10) !== -1000)
								_post[_dt['model']]['sshkey_id'] = this.sshkeyValue
						}

						// если выбран бэкап
						if (this.backupValue)
						{
							//_post[_dt['model']]['backup_id'] = this.backupValue
							delete _post[_dt['model']]
						}

						// если выбран iso
						if (this.reisoValue)
						{
							_post[_dt['model']]['reiso_id'] = this.reisoValue
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/reinstall_process_start')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// иная ошибка
									this.localErrorMessage = this.formatRequestError(resPost)

									// если что то передали для hostname
									if (_dt['fields'] && _dt['fields']['hostname'])
									{
										if (Array.isArray(_dt['fields']['hostname']))
										{
											if (_dt['fields']['hostname'].length)
												this.hostField['_errMsg'] = this.localeFtc(_dt['fields']['hostname'][0])
										}
										else this.hostField['_errMsg'] = this.localeFtc(_dt['fields']['hostname'])
									}

									// если что то передали для template_id
									if (_dt['fields'] && _dt['fields']['template_id'])
									{
										if (Array.isArray(_dt['fields']['template_id']))
										{
											if (_dt['fields']['template_id'].length)
												this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['template_id'][0])
										}
										else this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['template_id'])
									}

									// если что то передали для backup_id
									if (_dt['fields'] && _dt['fields']['backup_id'])
									{
										if (Array.isArray(_dt['fields']['backup_id']))
										{
											if (_dt['fields']['backup_id'].length)
												this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['backup_id'][0])
										}
										else this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['backup_id'])
									}

									// если что то передали для reiso_id
									if (_dt['fields'] && _dt['fields']['reiso_id'])
									{
										if (Array.isArray(_dt['fields']['reiso_id']))
										{
											if (_dt['fields']['reiso_id'].length)
												this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['reiso_id'][0])
										}
										else this.templateField['_errMsg'] = this.localeFtc(_dt['fields']['reiso_id'])
									}

									// если что то передали для sshkey_id
									if (_dt['fields'] && _dt['fields']['sshkey_id'])
									{
										if (Array.isArray(_dt['fields']['sshkey_id']))
										{
											if (_dt['fields']['sshkey_id'].length)
												this.sshkeyField['_errMsg'] = this.localeFtc(_dt['fields']['sshkey_id'][0])
										}
										else this.sshkeyField['_errMsg'] = this.localeFtc(_dt['fields']['sshkey_id'])
									}

									// покажем кнопку
									this.isReinstallStrated = false
									// покажем поля
									this.hostField._visible = true
									this.templateField._visible = true
									this.sshkeyField._visible = true
									// на этом все
									return
								}
							},
							// отрицательный ответ сервера
							resPost => {
								// покажем кнопку
								this.isReinstallStrated = false
								// покажем поля
								this.hostField._visible = true
								this.templateField._visible = true
								this.sshkeyField._visible = true
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// покажем кнопку
					this.isReinstallStrated = false
					// покажем поля
					this.hostField._visible = true
					this.templateField._visible = true
					this.sshkeyField._visible = true
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// покажем кнопку
					this.isReinstallStrated = false
					// покажем поля
					this.hostField._visible = true
					this.templateField._visible = true
					this.sshkeyField._visible = true
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'value': function(value) {
			this.templateValue = this.value
		},
		'template': function(template, old) {
			// если появилась инфа о шаблоне - значит нужно показать кнопку
			if (template) this.isReinstallStrated = false

			this.templateField = Object.assign({}, template)
		},
		'host': function(host, old) {
			// если раньше было установлено значение - значит это скорей всего конец переустановки,
			// и нужно показать кнопку
			if (old) this.isReinstallStrated = false

			this.hostField = Object.assign({}, host)
			if (this.hostField && this.hostField['value']) this.hostValue = this.hostField['value']
		},
		'sshkey': function(sshkey) {
			this.sshkeyField = Object.assign({}, sshkey)
			if (this.sshkeyField &&
				'value' in this.sshkeyField)
			{
				if (this.sshkeyField['value'])
				{
					this.sshkeyValue = this.sshkeyField['value']
					this.$nextTick(() => {
						this.showif()
					})
				}
				else
				{
					this.sshkeyValue = -1000
					this.$nextTick(() => {
						EventBus.$emit('w5-set-list-field-value', {
							name: 'sshkey_id',
							value: {
								'id': -1000,
								'name': this.localeFtc('sshkey/not_use')
							}
						})
						this.showif()
					})
				}
			}
		},
		'backup': function(backup) {
			this.backupField = Object.assign({}, backup)
		},
		'reiso': function(reiso) {
			this.reisoField = Object.assign({}, reiso)
		},
		'access': function(access, old) {
			// если раньше не было доступа, а сейчас есть - значит это скорей всего конец переустановки,
			// и нужно показать кнопку
			if (access && !old) this.isReinstallStrated = false

			this.Access = access
		},
		'status': function(status) {
			this.Status = status
		},
		'parentError': function(value) {
			this.Error = value
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// reinstall.vue?2b2aa7b2